import React from 'react';
import { Modal } from './Modal';
import { ModalToggleState } from '../models/actionStates';
import { useRecoilValue } from 'recoil';
import { modalState } from '../recoil/selectors';

const ModalSingletonApp = () => {
  const modal = useRecoilValue(modalState);
  return (
    <Modal isVisible={modal?.toggleState === ModalToggleState.Open} {...modal}>
      {modal?.contents}
    </Modal>
  );
};

export default ModalSingletonApp;
